import React from 'react';
interface SelectProps extends React.SelectHTMLAttributes<HTMLSelectElement> {
  label?: string;
  error?: string;
  options: {
    value: string;
    label: string;
  }[];
}
export function Select({
  label,
  error,
  options,
  className = '',
  id,
  ...props
}: SelectProps) {
  const selectId = id || props.name;
  return <div className="w-full" data-id="element-413">
      {label && <label htmlFor={selectId} className="block text-sm font-medium text-gray-700 mb-1" data-id="element-414">
          {label}
        </label>}
      <select id={selectId} className={`w-full px-4 py-3 rounded-md border ${error ? 'border-red-500 focus:ring-red-500 focus:border-red-500' : 'border-gray-300 focus:ring-cyan-500 focus:border-cyan-500'} shadow-sm focus:outline-none focus:ring-2 transition-colors bg-white ${className}`} {...props} data-id="element-415">
        {options.map(opt => <option key={opt.value} value={opt.value} data-id="element-416">
            {opt.label}
          </option>)}
      </select>
      {error && <p className="mt-1 text-sm text-red-600" data-id="element-417">{error}</p>}
    </div>;
}